/**
 * AppSync `AWSJSON` fields may be plain objects or JSON strings at runtime.
 */
export function parseCardAwsJsonField(value: unknown): unknown {
	if (typeof value === 'string') {
		const trimmed = value.trim();
		if (trimmed === '') {
			return {};
		}
		try {
			return JSON.parse(trimmed) as unknown;
		} catch {
			return value;
		}
	}
	return value;
}
